import React from "react";
import { getIcons, getLogos } from "../Constant/Constant";

const LeadLimitModel = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const icon = getLogos();

  const handelContactEmail = () => {
    const email = "greenlime@gmail.com";
    const subject = "Upgrade Request";
    const body = "Dear Greenlime Team, I would like to upgrade my lead limit.";

    window.open(`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, "_blank");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-[50px] rounded-lg shadow-lg w-[685px] h-[383px] relative">
        <button
          className="absolute top-5 right-4  text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          ✖
        </button>
        <img
          className="w-full h-[60px] mb-6"
          src={icon?.glfunnalTitle}
          alt="Logo"
        />
        <h2 className="text-[24px] font-semibold text-customGreen mb-3 text-center">
          You've hit your lead limit!
        </h2>
        <p className="text-[16px] text-center text-gray-600 mb-4">
          You've reached the maximum number of lead. Upgrade now to add more
          Leads and enjoy uninterrupted access
        </p>

        <div className="flex justify-center mt-[50px]">
          <button
            onClick={handelContactEmail}
            className="bg-customGreen text-white py-2 px-4 rounded-lg hover:bg-customGreen-600"
          >
            Upgrade Now
          </button>
        </div>


      </div>
    </div>
  );
};

export default LeadLimitModel;